import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  insuranceRenewalData: [],
  uniqueBuildingsList: [],
  uniqueAccountManager: [],
  insuranceRenewalStatusData: [],
};

const InsuranceRenewalSlice = createSlice({
  name: "insuranceRenewal",
  initialState,
  reducers: {
    setInsuranceRenewalData: (state, action) => {
      state.insuranceRenewalData = action.payload;
    },
    setUniqueBuildingsList: (state, action) => {
      state.uniqueBuildingsList = action.payload;
    },
    setUniqueAccountmanager: (state, action) => {
      state.uniqueAccountManager = action.payload;
    },
    setInsuranceRenewalStatusData: (state, action) => {
      state.insuranceRenewalStatusData = action.payload;
    },
  },
});
export const {
  setInsuranceRenewalData,
  setUniqueBuildingsList,
  setUniqueAccountmanager,
  setInsuranceRenewalStatusData,
} = InsuranceRenewalSlice.actions;

export default InsuranceRenewalSlice.reducer;
